module.exports = __webpack_public_path__ + "static/Come volare con le macchine su Adopt Me-61c97c52699cd245dc2afd9c483f01ff.mp4";